/* __next_internal_client_entry_do_not_use__ RightBanner auto */import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getDetailUrl } from "@/helpers/blog";
import { useTranslations } from "next-intl";
export const RightBanner = param => {
  let {
    popular
  } = param;
  const t = useTranslations();
  return /*#__PURE__*/_jsx("div", {
    className: "right-banner",
    children: /*#__PURE__*/_jsxs("div", {
      className: "right-banner-content",
      children: [/*#__PURE__*/_jsx("div", {
        className: "banner-title",
        children: t("Seo_Main_Nav_Popular")
      }), /*#__PURE__*/_jsx("div", {
        className: "popular-posts-list",
        children: popular.slice(0, 4).map((item, index) => {
          return /*#__PURE__*/_jsxs("a", {
            className: "popular-post",
            href: getDetailUrl(item.urlName, item.language),
            target: "_blank",
            children: [/*#__PURE__*/_jsx("div", {
              className: "post-category",
              children: item.category
            }), /*#__PURE__*/_jsx("p", {
              className: "post-title",
              children: item.title
            })]
          }, index);
        })
      })]
    })
  });
};